module.exports = __webpack_public_path__ + "6194068a248886221755df2512bff4d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-high-heels-s.png
// module id = 2387
// module chunks = 0